export const headNurseBaseAmount = [
    {
        base:85597
    }
]

export const headNursePayIncrease = [
    {
        id: "0",
        expDiff: 0
    },
    {
        id: "1",
        expDiff: 988
    },
    {
        id: "2",
        expDiff: 1972
    },
    {
        id: "3",
        expDiff: 1972
    },
    {
        id: "4",
        expDiff: 2958
    },
    {
        id: "5",
        expDiff: 3944
    },
    {
        id: "6",
        expDiff: 3944
    },
    {
        id: "7",
        expDiff: 4270
    },
    {
        id: "10",
        expDiff: 4929
    },
    {
        id: "13",
        expDiff: 5589
    },
    {
        id: "15",
        expDiff: 5915
    },
    {
        id: "17",
        expDiff: 6954
    },
    {
        id: "18",
        expDiff: 7481
    },
    {
        id: "20",
        expDiff: 8002
    },
]

export const headNurseLongevity = [
    {
        id: "None",
        amount: 0
    },
    {
        id: "5 but less than 7",
        amount: 1879
    },
    {
        id: "7 but less than 10",
        amount: 5865
    },
    {
        id: "10 but less than 15",
        amount: 7286
    },
    {
        id: "15 but less than 20",
        amount: 15108
    },
    {
        id: "20 but less than 22",
        amount: 19211
    },
    {
        id: "22 years or more",
        amount: 22113
    }
]

export const headNurseEducation = [
    {
        id: "Base Salary",
        amount: 0
    },
    {
        id: "Baccalaureate Differential",
        amount: 1952
    },
    {
        id: "Masters Differential",
        amount: 3909
    }
]